import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { logout } from "../../redux/actions/authActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faBell, faXmark } from "@fortawesome/free-solid-svg-icons";
import logo from "../../assets/logo.png";
import { setActiveSection } from "../../redux/actions/dashboardActions";
import { fetchLikesReceivedDonneurOrdre, fetchLikesSentDonneurOrdre } from "../../redux/actions/likeActions";
import GestionAppelsOffresV2 from "../../components/GestionAppelsOffresV2";
import logoutIcon from "../../assets/logout.png";
import NotificationsDashboard from "../../components/NotificationsDashboard";
import Factures from "../../components/Factures";

const DonneurOrdreDashboard = () => {
  const { user: authUser, token } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { activeSection } = useSelector(state => state.dashboard);
  const [menuOpen, setMenuOpen] = useState(false);
  const notifications = useSelector((state) => state.notification?.list || []); // non-lues si ton API renvoie que non-lues
  const unreadCount = notifications.length;
  const dispatch = useDispatch();
  const openNotifications = () => {
    dispatch(setActiveSection("notifications"));
    setMenuOpen(false);
  };
  useEffect(() => {
    if (!authUser) navigate("/");
  }, [authUser, navigate]);
  useEffect(() => {
    dispatch(fetchLikesReceivedDonneurOrdre(token));
    dispatch(fetchLikesSentDonneurOrdre(token));
  }, [token, dispatch]);

  useEffect(() => {
    if (activeSection === "")
      dispatch(setActiveSection("appelOffre"));
  }, [activeSection, dispatch]);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  // Mapping des sections disponibles
  const sections = {
    appelOffre: <GestionAppelsOffresV2 />,
    factures: <Factures/>,
    notifications: <NotificationsDashboard />,
    // tu ajoutes d’autres écrans au besoin
  };

  return (
    <main className="client-dashboard">
      {/* Menu latéral ou top selon device */}
      <nav className={`client-menu ${menuOpen ? "open" : ""}`}>
        {/* MOBILE HEADER (logo centered, icons top-right) */}
        <div className="mobile-header">
          <img src={logo} alt="Logo Intereseaux" className="logo-mobile" />

          <div className="mobile-top-icons">
            <button
              className="icon-btn notif-btn-mobile"
              onClick={openNotifications}
              aria-label="Notifications"
            >
              <FontAwesomeIcon icon={faBell} bounce={unreadCount > 0} />
              {unreadCount > 0 && <span className="notif-badge-mobile">{unreadCount}</span>}
            </button>

            <button
              className="icon-btn hamburger-btn"
              onClick={() => setMenuOpen((s) => !s)}
              aria-expanded={menuOpen}
              aria-label="Ouvrir le menu"
            >
              <FontAwesomeIcon icon={menuOpen ? faXmark : faBars} />
            </button>
          </div>
        </div>

        {/* DESKTOP LOGO */}
        <div className="logo-desktop">
          <a href="/espace-prestataire">
            <img src={logo} alt="Logo Intereseaux" className="logo-dashboard-img" />
          </a>
        </div>

        {/* DESKTOP BELL (centered under logo) */}
        <div className="notif-desktop-wrapper">
          <button className="icon-btn notif-btn-desktop" onClick={openNotifications} aria-label="Notifications">
            <FontAwesomeIcon icon={faBell} />
            {unreadCount > 0 && <span className="notif-badge-desktop">{unreadCount}</span>}
          </button>
        </div>
        <ul className="menu-items">
          <li
            className={activeSection === "appelOffre" ? "active" : ""}
            onClick={() => dispatch(setActiveSection("appelOffre"))}>
            Mes appels d'offres
          </li>
          <li
            className={activeSection === "factures" ? "active" : ""}
            onClick={() => dispatch(setActiveSection("factures"))}
          >
            Mes Factures
          </li>


          <li>
            <button className="logout-btn" onClick={handleLogout}>
              <img style={{ width: "30px", height: "30px", objectFit: "contain" }} src={logoutIcon} alt="icone logout" />
            </button>
          </li>
        </ul>
      </nav>

      {/* Zone de contenu */}
      <section className="admin-content">
        {sections[activeSection]}
      </section>
    </main>
  );
};

export default DonneurOrdreDashboard;
